import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { ReactComponent as SuccessIcon } from '../../../../../../assets/image/carbon/circle-wavy-check.svg';
import CarbonAdminResponseIcon from '../../../../../../assets/image/carbon/carbon-admin-response-icon';
import './CarbonFormHeader.scss';

const CarbonFormHeader = ({ isSubmitted, leakage }) => {
  const translate = useIntl();
  const adminSolution = leakage?.carbonApprove; // bool
  const adminMessage = leakage?.comment;
  // Check if carbon application was checked by the admin
  // Carbon application can be approved or rejected
  if (leakage) {
    return adminSolution ? (
      <div className="carbon-form-header__update carbon-form-header__update-success">
        <CarbonAdminResponseIcon solution={adminSolution} />
        <FormattedMessage
          id="carbon.formHeader.carbonApprove"
          values={{
            p: (...chunks) => <p>{chunks}</p>,
            strong: (chunks) => <strong>{chunks}</strong>,
            br: <br />,
          }}
        />
      </div>
    ) : (
      <div className="carbon-form-header__update carbon-form-header__update-failure">
        <CarbonAdminResponseIcon solution={adminSolution} />
        <FormattedMessage
          id="carbon.formHeader.afterReviewOfInformation"
          values={{
            p: (...chunks) => <p>{chunks}</p>,
            strong: (chunks) => <strong>{chunks}</strong>,
            br: <br />,
          }}
        />
        {adminMessage ? (
          <FormattedMessage
            id="carbon.formHeader.detailedInformation"
            values={{
              div: (...chunks) => <div className="carbon-form-header__update-adminMessage">{chunks}</div>,
              strong: (chunks) => <strong>{chunks}</strong>,
              adminMessage: <span>{adminMessage}</span>,
            }}
          />
        ) : null}
      </div>
    );
  }
  // Check if form was finalized and submitted by user
  if (isSubmitted) {
    return (
      <div className="carbon-form-header__submit-success">
        <SuccessIcon />
        <FormattedMessage
          id="carbon.formHeader.congratulations"
          values={{
            p: (...chunks) => <p>{chunks}</p>,
            br: <br />,
            link: (chunks) => (
              <a
                href="mailto:support@openforestprotocol.org"
                className="footer__contactUsEmail"
              >
                {chunks}
              </a>
            ),
          }}
        />
      </div>
    );
  }
  return (
    <>
      <p className="carbon-form-header__title">{translate.formatMessage({ id: 'carbon.formHeader.ofpNeedsToEnsureEligibility' })}</p>
      <p className="carbon-form-header__subtitle">{translate.formatMessage({ id: 'carbon.formHeader.saveAndComeBackLater' })}</p>
    </>
  );
};

export default CarbonFormHeader;
